import { render, staticRenderFns } from "./BriqDataTable.vue?vue&type=template&id=bab8c470&scoped=true&lang=pug&"
import script from "./BriqDataTable.vue?vue&type=script&lang=js&"
export * from "./BriqDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BriqDataTable.vue?vue&type=style&index=0&id=bab8c470&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8c470",
  null
  
)

export default component.exports